"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Text as t } from "../Text/Text.mjs";
import * as n from "react";
import { Fragment as r, jsx as i, jsxs as a } from "react/jsx-runtime";
import { Slot as o } from "@radix-ui/react-slot";
import { cva as s } from "class-variance-authority";
import { Action as c, Close as l, Provider as u, Root as d, Viewport as f } from "@radix-ui/react-toast";
import { CheckCircle as p, Close as m, InformationCircle as h, Microphone as g, WarningCircle as _ } from "@videoblocks/react-icons";
//#region src/components/atoms/Toast/Toast.tsx
var v = s("flex p-6 justify-between items-start rounded-sm border-l-8 shadow-level3-soft data-[state=open]:animate-in data-[state=open]:slide-in-from-right", { variants: { variant: {
	error: "border-l-red-500 bg-red-100 text-red-700",
	warning: "border-l-orange-500 bg-orange-100 text-orange-800",
	success: "border-l-green-500 bg-green-100 text-green-700",
	info: "border-l-blue-500 bg-blue-100 text-blue-700",
	neutral: "border-l-gray-500 bg-gray-200 text-black"
} } }), y = s("", { variants: { variant: {
	error: "fill-red-700",
	warning: "fill-orange-800",
	success: "fill-green-700",
	info: "fill-blue-700",
	neutral: "fill-black"
} } }), b = {
	error: _,
	warning: _,
	success: p,
	info: h,
	neutral: g
}, x = (t, n) => {
	let r = t || "neutral", a = b[r], o = /* @__PURE__ */ i(a, {
		"data-testid": `default-icon-${r}`,
		className: e("size-6", y({ variant: r }))
	});
	return n || o;
}, S = n.forwardRef(({ actionAltText: n, asChild: s = !1, hasClose: u = !0, icon: p = null, actionProps: h = {}, children: g, className: _ = "", duration: b = 2e4, title: S, variant: C = "neutral", viewportClassName: w, viewportProps: T, ...E }, D) => {
	let O = s ? o : "a", { altText: k, ...A } = h, j = n || k || "";
	return /* @__PURE__ */ a(r, { children: [/* @__PURE__ */ i(d, {
		className: e(v({ variant: C }), _),
		duration: b,
		"data-variant": C,
		...E,
		children: /* @__PURE__ */ a("div", {
			className: "flex items-center gap-3 flex-1",
			children: [
				/* @__PURE__ */ i("div", {
					className: "flex-shrink-0",
					children: x(C, p)
				}),
				typeof S == "string" && S ? /* @__PURE__ */ i(t, {
					fontSize: "sm",
					fontWeight: "regular",
					children: S
				}) : S,
				g && /* @__PURE__ */ i(c, {
					ref: D,
					className: "text-sm font-bold underline hover:no-underline cursor-pointer",
					altText: j,
					asChild: s,
					...A,
					children: /* @__PURE__ */ i(O, { children: g })
				}),
				u && /* @__PURE__ */ i(l, {
					className: "flex-shrink-0 p-1 hover:bg-gray-100 hover:cursor-pointer rounded transition-colors ml-auto",
					"aria-label": "Close",
					children: /* @__PURE__ */ i(m, { className: e("w-3 h-3", y({ variant: C })) })
				})
			]
		})
	}), (w || T) && /* @__PURE__ */ i(f, {
		className: w,
		...T
	})] });
});
S.displayName = "Toast";
var C = n.forwardRef(({ className: t, ...n }, r) => /* @__PURE__ */ i(f, {
	ref: r,
	className: e("fixed top-[var(--spacing-24)] right-[var(--spacing-6)] flex flex-col gap-[var(--spacing-2)] w-[var(--breakpoint-sm)] max-w-[calc(100vw-var(--spacing-12))] m-0 list-none z-[1050] outline-none", t),
	...n
}));
C.displayName = "ToastViewport";
var w = ({ children: e, ...t }) => /* @__PURE__ */ i(u, {
	swipeDirection: "right",
	...t,
	children: e
});
//#endregion
export { S as Toast, w as ToastProvider, C as ToastViewport };
